import { Expose } from "@nts/std/serialization";
import { AccessMode } from "@nts/std/types";
import type { ColumnInfoInterface } from '@nts/std/interfaces';
import { SettingsType } from "@nts/std/types";
import type { CustomCellRendererInterface } from '@nts/std/interfaces';
import { Subject } from "rxjs";

export class ColumnInfo implements ColumnInfoInterface {

  path: string;

  isExternal = false;

  @Expose()
  useFormattedValue = true;

  @Expose()
  isVisible = true;

  @Expose()
  isEnabled = true;

  @Expose()
  isExtension = false;

  @Expose()
  groupIndex = -1;

  @Expose()
  isGhost = false;

  @Expose()
  isAutoSize = true;

  isCustom = false;

  @Expose()
  securityAccess: AccessMode | null = null;

  @Expose()
  width: number;

  @Expose()
  propertyName: string;

  @Expose()
  fieldName: string;
  // TODO: Type?

  @Expose()
  propertyTypeName: string;

  @Expose()
  header: string;

  @Expose()
  headerTooltip: string;

  @Expose()
  position: number;

  @Expose()
  isDateTimeOffset: boolean;

  @Expose()
  settings: SettingsType;

  @Expose()
  customCellRendererComponent?: CustomCellRendererInterface;

  destroy$: Subject<void>;

  constructor(propertyName: string, path: string = null) {
    this.propertyName = propertyName;
    this.fieldName = path?.length > 0 ? path + '.' + propertyName + '.value' : propertyName + '.value';
    this.path = path?.length > 0 ? path : null;
    this.settings = SettingsType.PropertyType;
    this.destroy$ = new Subject<void>();
  }


  // TODO rivedere
  visitViewModelPropertySelection(row: any): any {
    // if (row != null) {
    //   return row.GetType().GetProperty(this.propertyName).GetValue(row, null);
    // }
    return null;
  }

  resourceName(): string {
    // return this.propertyType.name;
    return '';
  }


  // event PropertyChangedEventHandler PropertyChanged;

  // protected void OnPropertyChanged(string propName)
  // {
  //     if (PropertyChanged != null)
  //     {
  //         PropertyChanged(this, new PropertyChangedEventArgs(propName));
  //     }
  // }
}
